import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShareVariableService {
  private filteredOptionsSubject = new BehaviorSubject<any[]>([]);
  data: Observable<any[]> = this.filteredOptionsSubject.asObservable();

  updateListVariables(options: any[]): void {
    this.filteredOptionsSubject.next(options);
  }
}
